import React from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  Button,
} from "@mui/material";
import { getValidAccessToken } from "../utils/tokenUtils";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
const OfferUsersLists = () => {
  const [loading, setLoading] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [offerUsers, setOfferUsers] = React.useState([]);
  React.useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      const token = await getValidAccessToken();
      try {
        const response = await axios.get(`${apiUrl}/users/all-users`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setOfferUsers(response.data.data.offer_users || []);
        setLoading(false);
      } catch (error) {
        setErrorMessage("Failed to fetch users.");
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  const handleUserValidation = async (userId, isValid) => {
    const token = await getValidAccessToken();
    try {
      await axios.post(
        `${apiUrl}/users/validate-offer-user`,
        {
          user_id: userId,
          is_valid: isValid,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // Optionally update the UI or refetch the users list
    } catch (error) {
      setErrorMessage("Failed to update user validation status.");
    }
  };
  return (
    <Box sx={{ padding: 2 }}>
      <Typography variant="h5" gutterBottom>
        Pre book offer Users
      </Typography>
      <List>
        {offerUsers.map((user) => (
          <React.Fragment key={user.id}>
            <ListItem alignItems="flex-start">
              <ListItemText
                primary={`${user.first_name} ${user.last_name} (${user.email})`}
                secondary={
                  <>
                    <Typography
                      component="span"
                      variant="body2"
                      color="textPrimary"
                    >
                      Name: {user.first_name} {user.last_name}
                    </Typography>
                    <br />
                    <Typography
                      component="span"
                      variant="body2"
                      color="textPrimary"
                    >
                      User ID: {user.user_id}
                    </Typography>
                    <Typography
                      component="span"
                      variant="body2"
                      color="textPrimary"
                    >
                      {" "}
                      | Phone: {user.phone_number}
                    </Typography>
                    <br />
                    <Typography
                      component="span"
                      variant="body2"
                      color="textPrimary"
                    >
                      Registered On:{" "}
                      {new Date(user.registered_at).toLocaleDateString()}
                    </Typography>
                    <br />
                    <Typography
                      component="span"
                      variant="body2"
                      color="textPrimary"
                    >
                      Invoices:
                    </Typography>
                    <List sx={{ pl: 4 }}>
                      {user.invoice_details &&
                      user.invoice_details.length > 0 ? (
                        user.invoice_details.map((invoice) => (
                          <ListItem key={invoice.id} disablePadding>
                            <ListItemText
                              primary={`Invoice ID: ${invoice.invoice_id}, Transaction ID: $${invoice.transaction_id}, Transaction Details: ${invoice.transaction_details}`}
                            />
                          </ListItem>
                        ))
                      ) : (
                        <ListItem disablePadding>
                          <ListItemText primary="No invoices found." />
                        </ListItem>
                      )}
                    </List>
                    <br />
                    {user.valid_payment === "0" && (
                    <>    
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() =>
                        handleUserValidation(user.user_id, "valid_user")
                      }
                    >
                      Is Valid User
                    </Button>

                    <Button
                      variant="contained"
                      color="secondary"
                      sx={{ ml: 2 }}
                      onClick={() =>
                        handleUserValidation(user.user_id, "not_a_valid_user")
                      }
                    >
                      Not a Valid User
                    </Button>
                    </>
                    )}
                  </>
                }
              />
            </ListItem>
            <Divider component="li" />
          </React.Fragment>
        ))}
      </List>
    </Box>
  );
};

export default OfferUsersLists;
